var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareSalesMeetingScheduler = function SvgYeswareSalesMeetingScheduler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 19.422,
    fill: "#ECF6FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.636 23.293h-5.105a.464.464 0 0 1-.464-.465V19.58a1.856 1.856 0 1 0-3.713 0v8.818a1.392 1.392 0 0 1-2.785 0V24.22a.928.928 0 0 0-.928-.928H33.038a.464.464 0 0 1-.464-.463v-3.25a1.856 1.856 0 1 0-3.713 0v8.818a1.392 1.392 0 0 1-2.785 0V24.22a.928.928 0 0 0-.928-.928h-2.785a3.713 3.713 0 0 0-3.713 3.712v31.56a3.713 3.713 0 0 0 3.713 3.713h35.273a3.713 3.713 0 0 0 3.713-3.713v-31.56a3.713 3.713 0 0 0-3.713-3.712Zm-2.785 33.416H25.148a.928.928 0 0 1-.928-.928V37.216a.929.929 0 0 1 .928-.928h29.703a.928.928 0 0 1 .928.928V55.78a.929.929 0 0 1-.928.928Z",
    fill: "#29ABE2"
  })));
};
export default SvgYeswareSalesMeetingScheduler;